<template>
  <div class="container">
    <h4 class="title is-4">2FA</h4>
    <div class="container has-text-left">
      <b-table
          v-if="tableData.length > 0"
          :narrowed="true"
          :striped="true"
          :data="tableData"
      >
        <template slot-scope="props">
          <b-table-column field="num" class="is-hidden-mobile" numeric>{{props.row.num}}</b-table-column>
          <b-table-column field="name" label="Name">{{props.row.name}}</b-table-column>
          <b-table-column field="account" label="Account">{{props.row.account}}</b-table-column>
          <b-table-column field="url" label="URL">{{props.row.url}}</b-table-column>
          <b-table-column field="token" label="Token" numeric>
            <b-button type="is-success" class="is-small" @click="handleClickGetToken(props.row.id)">Get Token</b-button>
            <span style="margin-left: 1.5rem">
              {{props.row.token}}
            </span>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

  export default {
    components: {

    },
    name: "screen2fa",
    data() {
      return {

      };
    },
    computed: {
      ...mapGetters('twofactor', ['accounts']),
      tableData() {
        const ret = [];

        if (this.accounts) {
          let num = 0;
          this.accounts.forEach(item => {
            num += 1;
            const hftToken = item.token.length > 0 ? item.token : '-';
            ret.push({
              ...item,
              token: hftToken,
              num,
            });
          });
        }

        return ret;
      }
    },
    methods: {
      ...mapActions('twofactor', ['getToken']),
      handleClickGetToken(id) {
        this.getToken({
          id,
        });
      }
    },
    mounted() {

    },
    unmounted() {

    }
  }
</script>

<style scoped>

</style>
